import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import AdminDashboard from './components/admin/dashboard';
import CreatorList from './components/admin/creatorlist';
import CreatorWheelList from './components/admin/creatorWheelList';
import WheelDetails from './components/admin/wheelDetails';
import SubscribeList from './components/admin/subscribeList';
import WWheelEdit from './components/admin/wheeledit';

import './App.css';

function App() {
  return (
    <Router>
      <div className="content">

        <Routes>
          <Route path="/" element={<AdminDashboard />} />
          <Route path="/" element={<AdminDashboard />} />
          <Route path="/creatorList" element={<CreatorList />} />
          <Route path="/creator/list" element={< CreatorWheelList />} />
          <Route path="/wheel/details" element={<WheelDetails />} />
          <Route path="/subscribeList" element={<SubscribeList />} />
          <Route path="/wheeledit" element={<WWheelEdit />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
